/**
 * FormHandler
 * Steuert Contao-Formulare über AJAX und verwaltet Step-Stack.
 * - Beibehaltung des REQUEST_TOKEN
 * - Korrektur der Action-URL
 * - Unterstützung mehrstufiger Dialoge mit Zurück-Funktion
 */
export default class FormHandler {
  /**
   * @param {HTMLElement} container - Container für die Formulare
   * @param {Dialog} dialog - Dialog-Instanz
   * @param {AjaxLoader} ajaxLoader - AjaxLoader-Instanz
   */
  constructor(container, dialog, ajaxLoader) {
    this.container = container;
    this.dialog = dialog;
    this.ajaxLoader = ajaxLoader;
    this.stepStack = [];
  }

  /**
   * Initialisiert alle Formulare innerhalb eines Containers.
   * @param {HTMLElement} container
   */
  initAllForms(container = this.container) {
    const forms = container.querySelectorAll('form');
    console.log('[FormHandler] Initialisiere Formulare:', forms.length);
    forms.forEach(form => this.initForm(form));
  }

  /**
   * Sendet Formularinhalt via XMLHttpRequest ab.
   * @param {HTMLFormElement} form
   * @param {FormData} body
   * @param {Function} callback
   */
  request(form, body, callback) {
    this.stepStack.push(this.container.innerHTML);

    const actionUrl = form.action;
    console.log('[FormHandler] Absende an:', actionUrl);

    const xhr = new XMLHttpRequest();
    xhr.open('POST', actionUrl, true);
    xhr.setRequestHeader('Accept', 'text/html');
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.setRequestHeader(
      'X-Contao-Ajax-Form',
      form.querySelector('[name="FORM_SUBMIT"]').value
    );

    form.ariaBusy = 'true';
    form.dataset.ajaxForm = 'loading';

    xhr.onload = () => {
      console.log('[FormHandler] Antwort erhalten', xhr.status, xhr.responseURL);
      form.ariaBusy = 'false';
      form.dataset.ajaxForm = '';
      callback(xhr);
    };

    xhr.send(body || null);
  }

  /**
   * Initialisiert ein einzelnes Formular mit AJAX-Submit.
   * @param {HTMLFormElement} form
   */
  initForm(form) {
    const id = form.getAttribute('id') || '(ohne ID)';
    console.log('[FormHandler] Init form', id);

    if (!form.dataset.originalAction) {
      form.dataset.originalAction = form.action;
    }

    form.addEventListener('submit', (e) => {
      e.preventDefault();

      const formData = new FormData(form);
      if (e.submitter) {
        formData.append(e.submitter.name, e.submitter.value);
        e.submitter.disabled = true;
        setTimeout(() => (e.submitter.disabled = false), 30000);
      }

      this.request(form, formData, (xhr) => {
        const range = document.createRange();
        range.selectNode(form.parentNode);
        const fragment = range.createContextualFragment(xhr.responseText);
        const newForm = fragment.querySelector('form');

        if (!newForm) {
          console.error('[FormHandler] Kein neues Formular gefunden.');
          return;
        }

        const isInvalidAction =
          !newForm.getAttribute('action') ||
          newForm.action === '' ||
          newForm.action === window.location.origin + '/';

        if (isInvalidAction) {
          const fallbackAction =
            xhr.responseURL ||
            form.dataset.originalAction ||
            this.originalAction;

          if (fallbackAction) {
            console.log('[FormHandler] Korrigiere Action:', fallbackAction);
            newForm.action = fallbackAction;
            newForm.dataset.originalAction = fallbackAction;
          }
        } else {
          newForm.dataset.originalAction = newForm.action;
        }

        const oldToken = form.querySelector('[name="REQUEST_TOKEN"]');
        const newToken = newForm.querySelector('[name="REQUEST_TOKEN"]');
        if (!newToken && oldToken) {
          const hiddenToken = document.createElement('input');
          hiddenToken.type = 'hidden';
          hiddenToken.name = 'REQUEST_TOKEN';
          hiddenToken.value = oldToken.value;
          newForm.appendChild(hiddenToken);
        }

        form.replaceWith(newForm);
        this.initForm(newForm);
      });
    });
  }

  /**
   * Springt einen Step zurück, indem der vorherige Inhalt aus dem Stack geladen wird.
   */
  goBack() {
    if (this.stepStack.length > 0) {
      const prev = this.stepStack.pop();
      this.container.innerHTML = prev;
      this.initAllForms(this.container);
    }
  }
}
